import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../provider/AuthProvider';

/**
 * PermissionSync — re-reads the caller's own permissions on every navigation.
 *
 * AuthProvider syncs on mount and on tab focus, and neither happens during
 * ordinary use: someone who signs in and then works inside the tab, clicking
 * through the app without ever alt-tabbing, syncs exactly once at page load.
 * That left an admin's group change invisible until a hard refresh — the menu
 * still listed pages the user had lost, and the route gate still let them in.
 *
 * Navigation is the natural checkpoint. `syncPermissions` is already throttled
 * to one request per 30s and already swallows its own errors, so clicking fast
 * costs nothing and a failed sync mid-navigation cannot sign anyone out.
 *
 * Mounted once at the root of the authenticated route tree (routes/index.jsx),
 * beside ScrollToTop, which is the same shape. Deliberately NOT inside
 * ProtectedRoute: that renders at several nesting levels at once, so the effect
 * would fire two or three times per navigation.
 */
const PermissionSync = () => {
  const { pathname } = useLocation();
  const { syncPermissions } = useAuth();

  useEffect(() => {
    syncPermissions?.();
  }, [pathname, syncPermissions]);

  return null;
};

export default PermissionSync;
